import { render, staticRenderFns } from "./BalancesSpot.vue?vue&type=template&id=0ec275da&scoped=true"
import script from "./BalancesSpot.vue?vue&type=script&lang=js"
export * from "./BalancesSpot.vue?vue&type=script&lang=js"
import style0 from "./BalancesSpot.vue?vue&type=style&index=0&id=0ec275da&prod&lang=scss&scoped=true"
import style1 from "./BalancesSpot.vue?vue&type=style&index=1&id=0ec275da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec275da",
  null
  
)

export default component.exports